import { CanvasEventType, CommandType } from '../constants/Constants';
import BaseCommand from './BaseCommand';

/**
 * 橡皮擦工具
 *
 * @export
 * @class CmdEraser
 * @extends {BaseCommand}
 * @author zhenliang.sun
 */
export default class CmdEraser extends BaseCommand {
  constructor() {
    super();
    this.type = CommandType.Eraser;
  }

  execute() {
    super.execute();
    // 删除之前取消所有选中状态
    this.stage.deselectAll();
    this.stage.renderNow();
    this.root.on(CanvasEventType.Remove);
    this.root.on(CanvasEventType.Selected, e => {
      if (!this.executing) {
        return;
      }
      let item = e.target;

      this.root.remove(item);
    });
  }

  complete() {
    super.complete();
  }
}
